class SlidingSidebar {

    hide(next) {
        if (next !== this.content)
            this.sidebar.classList.remove('active');
    }

    show() {
        this.sidebar.classList.add('active');
    }

    init() {
        // console.log(this);
        this.toggler.addEventListener('mouseenter', () => this.show());
        this.toggler.addEventListener('mouseleave', (ev) => this.hide(ev.toElement));
        this.content.addEventListener('mouseleave', () => this.hide());
    }

    constructor(sidebar, toggler, content) {
        this.sidebar = document.querySelector(sidebar);
        this.toggler = document.querySelector(toggler);
        this.content = document.querySelector(content);

    }
}

export default SlidingSidebar;



// WEBPACK FOOTER //
// ./scripts/modules/sliding-sidebar.js